// extracted by mini-css-extract-plugin
module.exports = {"cc-question-sub-reply":"_2omFs","cc-question-sub-reply-ul":"_25Tij","cc-question-sub-reply-li":"_3WlPx","cc-question-sub-reply-load":"_2maEE"};